import * as React from "react";

const ArrowGalleryDesktop = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={145.372}
    height={588.599}
    viewBox="0 0 145.372 588.599"
    {...props}
  >
    <g
      id="Grupo_20"
      data-name="Grupo 20"
      transform="translate(-870.709 -1567.121)"
    >
      <g
        id="Icon_feather-arrow-down"
        data-name="Icon feather-arrow-down"
        transform="translate(905 1567.621)"
      >
        <path
          id="Trazado_4"
          data-name="Trazado 4"
          d="M18,595.6a.5.5,0,0,1-.5-.5V7.5a.5.5,0,0,1,1,0V595.1A.5.5,0,0,1,18,595.6Z"
          transform="translate(37.29 -7.5)"
          fill="#dadada"
        />
        <path
          id="Trazado_5"
          data-name="Trazado 5"
          d="M62.79,55.225a.5.5,0,0,1-.277-.084L7.223,18.416a.5.5,0,1,1,.553-.833L62.79,54.125,117.8,17.584a.5.5,0,1,1,.553.833L63.067,55.141A.5.5,0,0,1,62.79,55.225Z"
          transform="translate(-7.5 532.874)"
          fill="#dadada"
        />
      </g>
      <text
        id="Gallery"
        transform="translate(920.709 1845.176) rotate(-90)"
        fill="#dadada"
        fontSize={60}
        fontFamily="CutiveMono-Regular, Cutive Mono"
        letterSpacing="0.347em"
      >
        <tspan x={-189.608} y={0}>
          {"Gallery"}
        </tspan>
      </text>
    </g>
  </svg>
);

export default ArrowGalleryDesktop;
